import React, { useEffect } from "react";
import ArchitectureImg from '../Images/Architecture.jpg';
import UrlTag from "../components/UrlTag";
import { Link } from "react-router-dom";

const Architecture = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="z-20">
            <UrlTag />
            <div className="relative">
                <img src={ArchitectureImg} alt="Architecture" className="w-full h-[300px] md:h-[500px] object-cover" />
                <div className="absolute inset-0 bg-black opacity-40"></div>
                <div className="absolute bottom-0 left-0 py-4 sm:py-6 md:py-8 px-4 sm:px-6 md:px-8 lg:px-14">
                    <h1 className="text-white text-3xl sm:text-4xl font-bold">Architecture</h1>
                </div>
            </div>
            <div className="p-4 sm:p-8 md:p-16 max-w-[620px] mx-auto">
                <h1 className="text-2xl mb-4 tracking-tight">
                    Architecture at Architetive Designs
                </h1>
                <p className="text-lg mb-8 tracking-wider text-gray-700 font-light">
                    Architecture must be forward-looking and should aim to create the kind of world we would like to inhabit in the future. We believe design can be a catalyst for positive environmental change. Our work is an attempt to realize this vision and to produce buildings that are ahead of their time. The practice integrates the skills of architecture with engineering, both structural and environmental, urbanism, interior and industrial design, model and film making, geometry, materials research, and many more – our collegiate working environment is similar to a compact university. By working together from the outset, we learn from one another and combine our knowledge to devise fully integrated design solutions.
                </p>

                <div className="flex-col space-y-4">
                    <div className=" space-x-4">
                        <Link to='/projects'>
                            <button className="text-gray-500 bg-[#eeeeee] hover:bg-[#e6e6e6] rounded-full px-4 py-2">Projects</button>
                        </Link>
                        <Link to='/people'>
                            <button className="text-gray-500 bg-[#eeeeee] hover:bg-[#e6e6e6] rounded-full px-4 py-2">People</button>
                        </Link>
                        <Link to='/contact'>
                            <button className="text-gray-500 bg-[#eeeeee] hover:bg-[#e6e6e6] rounded-full px-4 py-2">Contact</button>
                        </Link>
                    </div>
                    <div>
                        <Link to='/careers/vacancies'>
                            <button className="text-gray-500 bg-[#eeeeee] hover:bg-[#e6e6e6] rounded-full px-4 py-2">Vacancies</button>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Architecture;